/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { useEffect, useState, useRef } from 'react';
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import { defineMessages, useIntl } from 'react-intl';

import './CookieConsentBanner.css';
import 'react-accessible-accordion/dist/fancy-example.css';

const COOKIE_NAME = 'cookie-consent';

const messages = defineMessages({
  main: {
    id: "volto-cookie-consent-main",
    defaultMessage: "We use cookies on our website to ensure the operation of the website, to develop the service and to target marketing. To accept the use of cookies, press Accept all cookies. "
  },
  readmore: {
    id: "volto-cookie-consent-read-more", 
    defaultMessage: "Read more."
  },
  acceptselected: {
    id: "volto-cookie-consent-acceptselected",
    defaultMessage: "Accept selected cookies"
  },
  acceptall: {
    id: "volto-cookie-consent-acceptall",
    defaultMessage: "Accept all cookies"
  },
  modify: {
    id: "volto-cookie-consent-modify",
    defaultMessage: "Modify cookie settings"
  },
  necessary: {
    id: "volto-cookie-consent-necessary",
    defaultMessage: "Necessary functional cookies"
  },
  socialmedia: {
    id: "volto-cookie-consent-socialmedia",
    defaultMessage: "Targeting, referral, and social media embedding cookies"
  },
  necessaryText: {
    id: "volto-cookie-consent-necessary-text",
    defaultMessage: "Necessary cookies are always used to make our pages work. We may use functional cookies to remember the choices you make, for example."
  },
  socialmediaTextPart1: {
    id: "volto-cookie-consent-socialmedia-text-part1",
    defaultMessage: "These cookies help us target communications and marketing based on how our pages are used."
  },
  socialmediaTextPart2: {
    id: "volto-cookie-consent-socialmedia-text-part2",
    defaultMessage: "The service can display content published on social media. Social media services (e.g. Facebook, Instagram, Twitter and YouTube) may use the information collected through cookies for their own use."
  },
  improve: {
    id: "volto-cookie-consent-improve",
    defaultMessage: "Cookies that we use to improve our site"
  },
  improveText: {
    id: "volto-cookie-consent-improveText",
    defaultMessage: "These cookies help us understand how our pages are used and what is expected of them. These cookies allow us to collect statistics about the use of our pages in Google Analytics in order to improve the performance of our pages."
  }

});

const CookieConsentBanner = ({ force, onClose }) => {

  const intl = useIntl();

  const [cookieValue, setCookieValue] = useState(
    getCookieConsentValue(COOKIE_NAME) || '',
  );
  const [statistics, setStatistics] = useState(cookieValue.match(/statistics/));
  const [marketing, setMarketing] = useState(cookieValue.match(/marketing/));
  const [showOptions, setShowOptions] = useState(false);
  const acceptLabel = intl.formatMessage(messages.acceptall);
  const declineLabel = showOptions
    ? intl.formatMessage(messages.acceptselected)
    : intl.formatMessage(messages.modify);

  const formRef = useRef();

  useEffect(() => {
    const consent = ['necessary'];
    if (statistics) {
      consent.push('statistics');
    }
    if (marketing) {
      consent.push('marketing');
    }
    setCookieValue(consent.join(','));
  }, [ marketing
     , statistics
     ]);

  return (
    <CookieConsent
      location="bottom"
      disableStyles={true}
      hideOnAccept={true}
      hideOnDecline={showOptions}
      buttonText={acceptLabel}
      ariaAcceptLabel={acceptLabel}
      declineButtonText={declineLabel}
      ariaDeclineLabel={declineLabel}
      cookieName={COOKIE_NAME}
      cookieValue="necessary,statistics,marketing"
      // cookieValue="necessary,marketing"
      declineCookieValue={cookieValue}
      setDeclineCookie={true}
      onDecline={() => {
        if (!showOptions) {
          setShowOptions(true);
          setTimeout(() => {
            if (formRef.current) {
              formRef.current.focus();
            }
            window.scrollTo(0, document.body.scrollHeight);
          }, 100);
        } else {
          setShowOptions(false);
          if (typeof onClose === 'function') {
            onClose();
          }
        }
      }}
      onAccept={() => {
        if (typeof onClose === 'function') {
          onClose();
        }
      }}
      debug={!!force}
      overlay={false}
      containerClasses="cookieConsentContainer"
      buttonClasses=""
      buttonWrapperClasses="cookieConsentButtons"
      declineButtonClasses=""
      buttonId=""
      declineButtonId=""
      contentClasses=""
      overlayClasses=""
      buttonStyle={{}}
      declineButtonStyle={{}}
      style={{}}
      contentStyle={{}}
      overlayStyle={{}}
      disableButtonStyles={true}
      enableDeclineButton={true}
      expires={365}
      flipButtons={false}
      sameSite="strict"
    >
      { intl.formatMessage(messages.main) } {" "}

      <a href="https://www.jyu.fi/evasteet" target="_blank">
        { intl.formatMessage(messages.readmore) }
      </a>
      {showOptions ? (
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          ref={formRef}
          tabIndex="0"
        >
          <Accordion
            allowMultipleExpanded={true}
            allowZeroExpanded={true}
            onChange={() => {
              window.scrollTo(0, document.body.scrollHeight);
            }}
          >
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <label
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                  >
                    <input type="checkbox" value="necessary" checked disabled />
                    { intl.formatMessage(messages.necessary) }
                  </label>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p>
                  { intl.formatMessage(messages.necessaryText) }
                </p>
                {/*<dl>*/}
                {/*  <dt>*/}
                {/*    <code>auth_token</code>*/}
                {/*  </dt>*/}
                {/*  <dd>Palvelun kirjautumiseväste.</dd>*/}
                {/*</dl>*/}
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <label
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                  >
                    <input
                      type="checkbox"
                      onChange={(e) => setStatistics(!!e.target.checked)}
                      checked={statistics}
                    />
                     { intl.formatMessage(messages.improve) } 
                  </label>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p>
                   { intl.formatMessage(messages.improveText) } 
                </p>
              </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <label
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                  >
                    <input
                      type="checkbox"
                      onChange={(e) => setMarketing(!!e.target.checked)}
                      checked={marketing}
                    />
                    { intl.formatMessage(messages.socialmedia) }
                  </label>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p>
                 { intl.formatMessage(messages.socialmediaTextPart1) }
                </p>
                <p>
                 { intl.formatMessage(messages.socialmediaTextPart2) }
                </p>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
        </form>
      ) : null}
    </CookieConsent>
  );
};

export default CookieConsentBanner;
